import { render, staticRenderFns } from "./VariantSelectionByDefault.vue?vue&type=template&id=eaf756ee&scoped=true&"
import script from "./VariantSelectionByDefault.vue?vue&type=script&lang=js&"
export * from "./VariantSelectionByDefault.vue?vue&type=script&lang=js&"
import style0 from "./VariantSelectionByDefault.vue?vue&type=style&index=0&id=eaf756ee&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eaf756ee",
  null
  
)

export default component.exports